/**
 * Coups de pouce — Attendu 1045 « Additionner, soustraire, multiplier des
 * nombres décimaux à une ou deux décimales » (automatisme 5e, rubrique
 * relatifs : décimaux POSITIFS uniquement).
 *
 * Doctrine exemple modélisant : le déroulé fait le geste, en langue d'élève,
 * par la NUMÉRATION (centièmes/dixièmes), « comme des entiers » en seule
 * phrase de méthode (une autorisation, pas une règle), retenue/emprunt
 * jamais nommés. Tout vit sur les SACRIFIÉS de gen_1045 (2,75 + 1,4, 1,5 × 4
 * et 4,5 × 1,5 : aucun ne sort en tirage) : invariant protégé par
 * cdp1045.self.test.js. Page 2 du produit (revue prof 2026-09-03) : deux
 * nombres à virgule, « des dixièmes fois des dixièmes, ça fait des
 * centièmes » — la même idée sert à 0,7 × 0,8 de la famille table + virgule.
 * Fiches CONDITIONNÉES au tirage (variantes par contenu.sousType, revue prof
 * 2026-09-03) : le QCM reçoit l'exemple de son opération (4,15 − 1,4 pour
 * une soustraction), le produit la page à une ou deux virgules.
 * PAS d'entrée pour ordre_grandeur_qcm : c'est du contrôle sans calcul,
 * toute aide utile (« multiplier par moins de 1 rend plus petit ») EST la
 * réponse — Tano sert son conseil générique.
 * Les explications post-réponse spécifiques vivent dans
 * contenu.explications du gen (verbalisation en centièmes, geste par
 * famille de produit).
 */

const PAGE_ADDITION = {
    titre: 'Fais pareil avec tes nombres',
    lignes: [
        '2,75 + 1,4 ?',
        '2,75 c\'est **275 centièmes**. 1,4 c\'est 1,40 : **140 centièmes**.',
        'J\'ajoute comme des entiers : **275 + 140 = 415**.',
        '415 centièmes, ça s\'écrit **4,15**.',
    ],
};

// La soustraction liée à la même paire (4,15 − 1,4), déjà sacrifiée.
const PAGE_SOUSTRACTION = {
    titre: 'Fais pareil avec tes nombres',
    lignes: [
        '4,15 − 1,4 ?',
        '4,15 c\'est **415 centièmes**. 1,4 c\'est 1,40 : **140 centièmes**.',
        'Je soustrais comme des entiers : **415 − 140 = 275**.',
        '275 centièmes, ça s\'écrit **2,75**.',
    ],
};

// Le QCM porte contenu.sousType (addition / soustraction, posé par gen_1045) :
// il reçoit l'exemple de SON opération. La série à trous mélange les deux
// opérations et n'a pas de marque : les deux pages.
const FICHE_SOMMES = {
    variantes: [
        { sousType: 'addition', pages: [PAGE_ADDITION] },
        { sousType: 'soustraction', pages: [PAGE_SOUSTRACTION] },
    ],
    defaut: { pages: [PAGE_ADDITION, PAGE_SOUSTRACTION] },
};

const PAGE_UNE_VIRGULE = {
    titre: 'Fais pareil avec tes nombres',
    lignes: [
        '1,5 × 4 ?',
        '1,5 c\'est **15 dixièmes**.',
        'Je multiplie comme des entiers : **15 × 4 = 60**.',
        '60 dixièmes, ça s\'écrit **6**.',
    ],
};

const PAGE_DEUX_VIRGULES = {
    titre: 'Deux nombres à virgule',
    lignes: [
        '4,5 × 1,5 ?',
        '4,5 c\'est **45 dixièmes**. 1,5 c\'est **15 dixièmes**.',
        'Je multiplie comme des entiers : **45 × 15 = 675**.',
        'Des dixièmes fois des dixièmes, ça fait des **centièmes** : 675 centièmes, ça s\'écrit **6,75**.',
        'Et des centièmes fois des dixièmes, ça fait des **millièmes**.',
    ],
};

// Routage par contenu.sousType, posé par gen_1045 selon le tirage (revue prof
// 2026-09-03) : l'élève qui a 0,7 × 0,8 voit la page à deux virgules, celui
// qui a 0,06 × 7 la page à une virgule. Sans marque (ancienne question) : les
// deux pages.
const FICHE_PRODUIT = {
    variantes: [
        { sousType: 'deux_virgules', pages: [PAGE_DEUX_VIRGULES] },
        { sousType: 'une_virgule', pages: [PAGE_UNE_VIRGULE] },
    ],
    defaut: { pages: [PAGE_UNE_VIRGULE, PAGE_DEUX_VIRGULES] },
};

const CP_1045 = {
    sommes_texte_trou_saisie: FICHE_SOMMES,
    alignement_qcm: FICHE_SOMMES,
    produit_reflechi_saisie: FICHE_PRODUIT,
    // ordre_grandeur_qcm : volontairement absent (l'aide dirait la réponse).
};

export default CP_1045;
